import React from 'react';
import Typography from '@material-ui/core/Typography';

import IndexedSettingsTabs from '../components/IndexedSettingsTabs';
import { MyTimePicker } from '../FormWidgets/DatePicker';
import Desc from '../FormWidgets/Description';
import { SettingGroup, ValueBox } from '../FormWidgets/SettingGroup';
import { EventGapSelect } from '../FormWidgets/Select';

export function StaticIntervalEditor({ controller, getValue, getUnsaved, onChange, disabled }) {
  return (
    <>
      {['day', 'night'].map((phase) => (
        <SettingGroup key={phase} controller={controller} id={`interval_${phase}`}>
          {['on', 'off'].map((type) => (
            <ValueBox key={type} controller={controller} id={'scheduling_'}>
              <Typography gutterBottom>
                <Desc id={`interval_${type}_${phase}`} show={`interval_${type}_${phase}`} />
              </Typography>
              <MyTimePicker
                disabled={disabled}
                value={getValue(`${type}_${phase}`)}
                unsaved={getUnsaved?.(`${type}_${phase}`)}
                seconds={true}
                name={`interval_${type}_${phase}`}
                onChange={(value) => onChange(`${type}_${phase}`, value)}
              />
            </ValueBox>
          ))}
        </SettingGroup>
      ))}
    </>
  );
}

export function StaticEventEditor({
  controller,
  getValue,
  getControllerValue,
  getUnsaved,
  onTimeChange,
  onGapChange,
  disabled,
  startSeconds = false
}) {
  return (
    <SettingGroup controller={controller} id={'event'}>
      <ValueBox controller={controller} id={'scheduling_'}>
        <Typography gutterBottom>
          <Desc id="event_start" show="event_start" />
        </Typography>
        <MyTimePicker
          disabled={disabled}
          value={getValue('start')}
          unsaved={getUnsaved?.('start')}
          seconds={startSeconds}
          name="event_start"
          onChange={(value) => onTimeChange('start', value)}
        />
      </ValueBox>
      <ValueBox controller={controller} id={'scheduling_'}>
        <Typography gutterBottom>
          <Desc id="event_duration" show="event_duration" />
        </Typography>
        <MyTimePicker
          disabled={disabled}
          value={getValue('duration')}
          unsaved={getUnsaved?.('duration')}
          seconds={true}
          name="event_duration"
          onChange={(value) => onTimeChange('duration', value)}
        />
      </ValueBox>
      <ValueBox controller={controller} id={'scheduling_'}>
        <Typography gutterBottom>
          <Desc id="event_exec_gap" show="event_exec_gap" />
        </Typography>
        <EventGapSelect
          disabled={disabled}
          value={getValue('exec_gap')}
          controller_value={getControllerValue?.('exec_gap')}
          onChange={(event) => onGapChange(event.target.value)}
        />
      </ValueBox>
    </SettingGroup>
  );
}

export function StaticIntervalTabs({
  ids,
  t,
  idPrefix,
  controller,
  getValue,
  getUnsaved,
  onChange,
  isEnabled,
  renderToggle,
  renderInfo,
  disabled,
  appBarStyle
}) {
  const items = ids.map((id) => ({ id, label: t(`interval_${id}`) }));
  return (
    <IndexedSettingsTabs
      items={items}
      idPrefix={idPrefix}
      appBarStyle={appBarStyle}
      contained={true}
      renderPanel={({ id }) => (
        <>
          {renderToggle?.(id)}
          {renderInfo?.(id)}
          {isEnabled?.(id) !== false && (
            <StaticIntervalEditor
              controller={controller}
              disabled={typeof disabled === 'function' ? disabled(id) : disabled}
              getValue={(field) => getValue(id, field)}
              getUnsaved={(field) => getUnsaved?.(id, field)}
              onChange={(field, value) => onChange(id, field, value)}
            />
          )}
        </>
      )}
    />
  );
}

export function StaticEventTabs({
  ids,
  t,
  idPrefix,
  controller,
  getValue,
  getControllerValue,
  getUnsaved,
  onTimeChange,
  onGapChange,
  startSeconds,
  isEnabled,
  renderToggle,
  renderInfo,
  disabled,
  appBarStyle
}) {
  const items = ids.map((id) => ({ id, label: t(`event_${id}`) }));
  return (
    <IndexedSettingsTabs
      items={items}
      idPrefix={idPrefix}
      appBarStyle={appBarStyle}
      contained={true}
      renderPanel={({ id }) => (
        <>
          {renderToggle?.(id)}
          {renderInfo?.(id)}
          {isEnabled?.(id) !== false && (
            <StaticEventEditor
              controller={controller}
              disabled={typeof disabled === 'function' ? disabled(id) : disabled}
              getValue={(field) => getValue(id, field)}
              getControllerValue={(field) => getControllerValue?.(id, field)}
              getUnsaved={(field) => getUnsaved?.(id, field)}
              onTimeChange={(field, value) => onTimeChange(id, field, value)}
              onGapChange={(value) => onGapChange(id, value)}
              startSeconds={startSeconds}
            />
          )}
        </>
      )}
    />
  );
}
